import { render, staticRenderFns } from "./AddressFinancialSponsorForm.vue?vue&type=template&id=602064b6&scoped=true&"
import script from "./AddressFinancialSponsorForm.vue?vue&type=script&lang=ts&"
export * from "./AddressFinancialSponsorForm.vue?vue&type=script&lang=ts&"
import style0 from "./AddressFinancialSponsorForm.vue?vue&type=style&index=0&id=602064b6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "602064b6",
  null
  
)

export default component.exports